export const navbar = {
  about: 'ABOUT',
  solutions: 'SOLUTIONS',
  articles: 'RESEARCH',
  news: 'NEWS',
  contacts: 'CONTACTS',
  recruit: 'RECRUIT',
  aboutStory: '企業紹介',
  aboutCompetency: 'コア・コンピテンシー',
  aboutHistory: '会社沿革',
  aboutPeople: 'ピープル',
  aboutPartner: 'パートナー',
  aboutCI: 'CI',
  digitalHealthcare: 'デジタルヘルスケア',
  digitalSports: 'デジタルスポーツ',
  newsArticles: '記事',
  newsNotice: 'お知らせ',
  newsEvents: 'イベント',
  recruitSystem: '人事制度',
  recruitJobs: '採用情報'
};

export default navbar;
